module.exports = __webpack_public_path__ + "media/images/matchdaySelector__md2--selected-42935d3fddd2477317dee8c2977625f4.png";